import {
  RouteRef,
  SubRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  materializedSegments = 'materializedSegments',
  materializedSegment = 'materializedSegment',
  materializedSegmentLoadJob = 'materializedSegmentLoadJob',
}

// Internal route refs for this plugin's own routing
export const materializedSegmentsRouteRef = createRouteRef({
  id: RoutesIds.materializedSegments,
});
export const rootRouteRef = materializedSegmentsRouteRef;
export const materializedSegmentRouteRef = createSubRouteRef({
  id: RoutesIds.materializedSegment,
  parent: rootRouteRef,
  path: '/:id',
});
export const materializedSegmentLoadJobRouteRef = createSubRouteRef({
  id: RoutesIds.materializedSegmentLoadJob,
  parent: rootRouteRef,
  path: '/:id/load-job-create',
});

export const Routes = {
  materializedSegments: materializedSegmentsRouteRef,
  materializedSegment: materializedSegmentRouteRef,
  materializedSegmentLoadJob: materializedSegmentLoadJobRouteRef,
} satisfies Record<RoutesIds, RouteRef | SubRouteRef>;
